var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BarraCrud',{attrs:{"showTitle":_vm.showTitle,"botaoNovo":true,"nomeCustomizado":"Fornecedores","onNovo":_vm.novo,"onFiltrar":_vm.filtrar}}),_c('FornecedoresTable',{ref:"fornecedorTable",attrs:{"filtro":_vm.filtro}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }